'use client'
import { Flex, Container, Group, ActionIcon, rem, Text } from '@mantine/core';
import { IconBrandTwitter, IconBrandYoutube, IconBrandInstagram, IconBrandFacebook } from '@tabler/icons-react';
import { MantineLogo } from '@mantinex/mantine-logo';
import { Image } from '@mantine/core';
import classes from './FooterSocial.module.css';
import { useMediaQuery } from '@mantine/hooks';

export default function Footer() {

  const isMobile = useMediaQuery('(max-width: 768px)')

  return (
    <div className='w-full'>
      <Flex className='flex-row justify-between p-4 items-center'>
        {/* <MantineLogo size={28} /> */}
        <Flex direction='row'>
          <Image
            w={isMobile ? 150 : 250}
            h={isMobile ? 24 : 40}
            src={'/welist-footer.png'}
          />
        </Flex>
        <Group gap={0} className={classes.links} align='center' justify="flex-end" wrap="nowrap">
          <a href='/privacy'><Text size='sm' c='gray'>Privacy Policy</Text></a>
          <a href='https://www.facebook.com/WeListAI' target='_blank'>
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconBrandFacebook style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
            </ActionIcon>
          </a>
          <a href='https://www.youtube.com/@WeListAI' target='_blank'>
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconBrandYoutube style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
            </ActionIcon>
          </a>
          {/* <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandTwitter style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
          </ActionIcon> */}
          {/* <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandYoutube style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
          </ActionIcon>
          <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandInstagram style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
          </ActionIcon> */}
        </Group>
      </Flex>
    </div>
  );
}